export const reset = ({ dispatch, commit }) => {
  commit('RESET')
}

export const saveBranchData = ({ dispatch, commit }, treeItemData) => {
  commit('SAVE_BRANCH_DATA', treeItemData)
}

export const saveOpenBranch = ({ dispatch, commit }, id) => {
  commit('SAVE_OPEN_BRANCH', id)
}

export const saveRootData = ({ dispatch, commit }, rootData) => {
  commit('SAVE_ROOT_DATA', rootData)
}

export const removeOpenBranch = ({ dispatch, commit }, id) => {
  commit('REMOVE_OPEN_BRANCH', id)
}

export const selectBranch = ({ dispatch, commit }, branch) => {
  commit('SELECT_BRANCH', branch)
}

export const startLoading = ({ dispatch, commit }) => {
  commit('SET_LOADING', true)
}

export const stopLoading = ({ dispatch, commit }) => {
  commit('SET_LOADING', false)
}



// WEBPACK FOOTER //
// ./src/store/modules/tree/actions.js